module.exports = __webpack_public_path__ + "static/media/savvy-website.cee15485.svg";